import { useEffect } from 'react';

export const useSetSuccessBackground = ({
  shouldDisplaySuccessBackground,
}: {
  shouldDisplaySuccessBackground: boolean;
}) => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const mainElement = document.getElementById('main-gradient');

    if (!mainElement) {
      return;
    }

    if (!shouldDisplaySuccessBackground) {
      return;
    }

    mainElement.classList.replace('background-gradient', 'background-gradient-success');

    return () => {
      mainElement.classList.replace('background-gradient-success', 'background-gradient');
    };
  }, [shouldDisplaySuccessBackground]);
};
